import {TranslateLoader} from "@ngx-translate/core";
import {from, Observable} from "rxjs";

/**
 * A class used to load translation files for specific languages in the application.
 * Implements the `TranslateLoader` interface.
 */
export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    // Map old/deprecated language codes to new ones
    const languageMap: Record<string, string> = {
      ee: 'et' // Redirect "ee" to "et"
    };

    // Resolve the actual language to use
    const resolvedLang = languageMap[lang] || lang;

    // Import the resolved language file
    return from(import(`./assets/i18n/${resolvedLang}.json`));
  }
}
